/* ==========================================================================
   A+ sections — see sections/aplus-story.liquid and aplus-rooms.liquid.

   Story: the <video> lives in a <template> until the play button is pressed,
   so the page downloads nothing for it up front. Then it replaces the poster
   and starts with native controls.

   Rooms: the map in each room follows the size picked in the buy box, with
   the same true-scale-then-capped maths the Liquid uses for the first paint.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__aplusBound) return;
  window.__aplusBound = true;

  /* --- rooms ------------------------------------------------------------- */

  function normalize(value) {
    return String(value == null ? '' : value).toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function sizeInputs(root) {
    var option = root.dataset.optionIndex;
    var id = root.dataset.productId;
    if (!option || option === '0') return [];
    // Scoped to this product's form: recommendations and quick-shop render
    // variant inputs too (same as size-guide.js).
    return Array.prototype.slice.call(document.querySelectorAll(
      'input[data-variant-input][data-index="option' + option + '"]' + (id ? '[form$="-' + id + '"]' : '')
    ));
  }

  function fitRooms(root, sizes) {
    var checked = sizeInputs(root).filter(function (input) { return input.checked; })[0];
    if (!checked) return;
    var wanted = normalize(checked.value);
    var size = sizes.filter(function (s) { return normalize(s.value) === wanted; })[0];
    if (!size || !size.w || !size.h) return;

    var aspect = size.w / size.h;
    root.querySelectorAll('[data-aplus-room]').forEach(function (room) {
      var roomCm = Number(room.dataset.roomCm) || 0;
      var maxW = Number(room.dataset.maxW) || 78;
      var maxH = Number(room.dataset.maxH) || 40;
      var width = roomCm > 0 ? size.w * 100 / roomCm : maxW;
      width = Math.min(width, maxW, maxH * aspect);
      room.style.setProperty('--art-w', width.toFixed(2) + '%');
      room.style.setProperty('--art-ratio', aspect.toFixed(4));
    });
  }

  function initRooms() {
    document.querySelectorAll('[data-aplus-rooms]').forEach(function (root) {
      var data = root.querySelector('[data-aplus-rooms-sizes]');
      var sizes = [];
      try { sizes = JSON.parse(data ? data.textContent : '[]'); } catch (error) {}
      if (!sizes.length) return;

      sizeInputs(root).forEach(function (input) {
        input.addEventListener('change', function () { fitRooms(root, sizes); });
      });
      fitRooms(root, sizes);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRooms);
  } else {
    initRooms();
  }

  /* --- story video ------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-aplus-video-play]');
    if (!button) return;

    var media = button.closest('[data-aplus-video]');
    var template = media && media.querySelector('[data-aplus-video-template]');
    if (!template) return;

    var video = template.content.querySelector('video');
    if (!video) return;
    video = video.cloneNode(true);

    var poster = media.querySelector('.aplus-story__poster');
    if (poster) poster.remove();
    button.remove();

    media.appendChild(video);
    // A browser that refuses to start it with sound (autoplay policy) still
    // allows it muted; the native controls let the viewer unmute.
    var played = video.play();
    if (played && played.catch) {
      played.catch(function () {
        video.muted = true;
        var retry = video.play();
        if (retry && retry.catch) retry.catch(function () {});
      });
    }
    video.focus();
  });
})();
